package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.ability.*
import org.jbox2d.common.*

class AbilityApplySystem(
    private val physicWorld: org.jbox2d.dynamics.World = World.inject(),
) : IteratingSystem(family { all(AbilityComponent) }) {

    private val tempVector = Vec2()
    override fun onTickEntity(entity: Entity) {
        val abilityComponent = entity[AbilityComponent]

        if (abilityComponent.fireBolt.isTouched) {
            // apply
            val abilityPosition = abilityComponent.body.position
            abilityComponent.fireBolt.getTargets().forEach { target ->
                val targetX = target.body.position.x
                val targetY = target.body.position.y

                if (targetX > abilityPosition.x) {
//                    tempVector.x = (targetX - abilityPosition.x) * 8
                    tempVector.x = 1.5f
                } else {
//                    tempVector.x = (abilityPosition.x - targetX) * 8
                    tempVector.x = -1.5f
                }

                if (targetY > abilityPosition.y) {
//                    tempVector.y = (abilityPosition.y - targetY) * 8
                    tempVector.y = -1.5f
                } else {
//                    tempVector.y = (targetY - abilityPosition.y) * 8
                    tempVector.y = 1.5f
                }

                target.body.applyLinearImpulse(tempVector, target.body.worldCenter, true)
                tempVector.setZero()
            }

            // remove
            entity.remove()
        }
    }
}
